<script lang="ts">
    import type * as t from "~/types";
    import { cn } from "~/utils";
    import { getContext } from "./context";
    import ShopifyCdnImage from "~/components/ShopifyCdnImage.svelte";
    import ActionButton from "~/components/ActionButton.svelte";

    export let option: t.MultipleChoiceOption;

    const ctx = getContext();
</script>

<ActionButton
    buttonStyle={$ctx.selectedOption == option
        ? "gradient-background"
        : "gradient-outline"}
    on:click={() => {
        $ctx.selectOption(option);
    }}
    class="option"
>
    <div slot="title">
        {#if option.icon}
            <ShopifyCdnImage
                image={option.icon}
                maxWidth={60}
                maxHeight={60}
                class={cn(
                    "aspect-square w-8 object-contain transition-[filter]",
                    option == $ctx.selectedOption && "invert",
                )}
            />
        {/if}
        {option.title}
    </div>
</ActionButton>
